export enum FlowerBoxType {
  CadFlowerbox = 'cad-flowerbox',
  FlowerBox18x6x5 = 'flowerbox-18-6-5',
  FlowerBox24x6x5 = 'flowerbox-24-6-5',
  FlowerBox36x6x5 = 'flowerbox-36-6-5',
  FlowerBox48x6x5 = 'flowerbox-48-6-5',
  FlowerBoxApple18 = 'flowerbox-apple-18',
  FlowerBoxApple24 = 'flowerbox-apple-24',
  FlowerBoxApple30 = 'flowerbox-apple-30',
  FlowerBoxPolywood18 = 'flowerbox-polywood-18',
  FlowerBoxPolywood24 = 'flowerbox-polywood-24',
  FlowerBoxPolywood30 = 'flowerbox-polywood-30',
  FlowerBoxWindowWidth65 = 'flowerbox-window-width-6-5',
  FlowerBoxNone = 'flowerbox-none',
}
